import type {WorkSummary} from 'api/types';
import type {CodeListMap} from 'schemaDefinition/types';
import type {WorkHit} from 'services/elastic/types';
import {mapWorkMetadataToWorkSummary} from './mapWorkMetadataToWorkSummary';

export const mapWorkHitToWorkSummary = (
  workHit: WorkHit,
  codelists: CodeListMap,
): WorkSummary => {
  return mapWorkMetadataToWorkSummary(workHit, codelists);
};
